import React from "react";
import clsx from "clsx";

type VezaIconProps = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

const VezaIcon = ({ className, ...props }: VezaIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 233 212"
    fill="currentColor"
    className={clsx(className)}
    {...props}
  >
    <title>{"Veza Logo"}</title>
    <path
      fillRule="evenodd"
      d="M95.537 49.013a2.44 2.44 0 0 1 0 3.449L62.493 85.506c-5.524 5.524-5.524 14.48 0 20.004l43.818 43.818c5.524 5.524 14.48 5.524 20.004 0l43.818-43.818c5.524-5.524 5.524-14.48 0-20.004l-19.888-19.888a4.878 4.878 0 0 0-6.899 0L131.193 77.77a4.879 4.879 0 0 0 0 6.9l9.115 9.113a2.44 2.44 0 0 1 0 3.45l-22.27 22.27a2.44 2.44 0 0 1-3.45 0l-22.27-22.27a2.44 2.44 0 0 1 0-3.45l60.373-60.372a2.44 2.44 0 0 1 3.45 0l40.664 40.664c11.837 11.837 11.837 31.029 0 42.866L137.746 176c-11.837 11.838-31.029 11.838-42.866 0l-59.06-59.059c-11.837-11.837-11.837-31.029 0-42.866l40.665-40.664a2.44 2.44 0 0 1 3.45 0l15.602 15.602Zm-78.768 6.01L68.777 3.202c6.075-4.675 14.822-4.23 20.388 1.337l27.148 27.148 27.148-27.148c6.05-6.05 15.859-6.05 21.909 0l50.487 50.486c22.359 22.359 22.359 58.61 0 80.968l-59.06 59.06c-22.359 22.359-58.61 22.359-80.968 0l-59.06-59.06c-22.359-22.358-22.359-58.61 0-80.968Z"
      clipRule="evenodd"
    />
  </svg>
);

export default VezaIcon;

